module.exports = __webpack_public_path__ + "img/Roboto-Light-webfont.ae03617c.svg";